/**
 * AssetsStep.jsx
 * ==============
 * Simplified asset upload for setup wizard
 * After this step, AI generation happens using uploaded assets
 */

import React from 'react';
import { useParams } from 'react-router-dom';
import SetupWizard from './SetupWizard';
import AssetManager from '../Assets/AssetManager';

const AssetsStep = () => {
  const { appName } = useParams();

  return (
    <SetupWizard currentStepKey="assets">
      <div style={{
        backgroundColor: 'white',
        borderRadius: '12px',
        border: '1px solid #E5E7EB',
        padding: '32px'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: '#111827',
          marginBottom: '8px'
        }}>
          📸 Upload Your Assets
        </h2>
        <p style={{
          fontSize: '14px',
          color: '#6B7280',
          marginBottom: '24px'
        }}>
          Add images, logos, and files that you'll use in your app. You can always add more later.
        </p>

        <div style={{
          padding: '24px',
          backgroundColor: '#F9FAFB',
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <h3 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#111827',
            marginBottom: '12px'
          }}>
            💡 Quick Tips:
          </h3>
          <ul style={{
            fontSize: '14px',
            color: '#6B7280',
            margin: 0,
            paddingLeft: '20px'
          }}>
            <li>Upload a logo (recommended: 200x200px)</li>
            <li>Add 2-3 images for your pages</li>
            <li>Upload any documents you want to share</li>
            <li><strong>💡 Pro tip:</strong> AI will analyze your assets to create better pages!</li>
            <li>Don't have assets yet? Click "Continue" to generate with placeholders</li>
          </ul>
        </div>

        {/* Embed AssetManager */}
        <div style={{ marginTop: '24px' }}>
          <AssetManager appId={appName} wizardMode={true} />
        </div>
      </div>
    </SetupWizard>
  );
};

export default AssetsStep;

